export default __webpack_public_path__ + "img/cHwRNUTw.72c70a88.svg";